<template>
    <CommonComponentsCardChangingCards v-model="curIndex" :card-data-list="cardList" iconed>
        <template #card-des>
            <div class="academy-custom-changing-cards-des">
                <div
                    v-for="(cardSubtitleItem, subIndex) in cardList[curIndex].subTitle"
                    :key="subIndex"
                    class="academy-custom-changing-cards-des-item"
                >
                    <span class="academy-custom-changing-cards-des-check">
                        <CommonComponentsSVGCommonCheckIcon />
                    </span>
                    <span>
                        {{ $t(cardSubtitleItem) }}
                    </span>
                </div>
            </div>
        </template>
    </CommonComponentsCardChangingCards>
</template>

<script lang="ts" setup>
    const curIndex = ref(0);

    defineProps<{
        cardList: Array<{
            title: string;
            subTitle: string;
            des: string;
        }>;
    }>();
</script>

<style lang="less" scoped>
    .academy-custom-changing-cards-des {
        color: #fff;
        font-family: HarmonyOS Sans SC;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        gap: 10px 20px;
        flex-wrap: wrap;

        &-item {
            font-size: 12px;
            display: flex;
            gap: 5px;

            white-space: nowrap;
        }

        &-check {
            display: flex;
            align-items: center;
            :deep(.svg-check-icon) {
                height: 14px;
                width: 7px;
            }
        }
    }
</style>
